import Vue from 'vue';
import Vuetify from 'vuetify';
import colors from 'vuetify/es5/util/colors';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  iconfont: 'md',
  rtl: true,
  theme: {
    themes: {
      light: {
        primary: colors.blue.lighten2,
        secondary: colors.blue.lighten4,
        accent: colors.green.base
      }
    }
  }
});
